import {ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {AbstractVisbosComponent} from "../../../core/visbos-core/components/abstract-visbos.component";
import {Apollo, ApolloQueryObservable} from "apollo-angular";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {GenericModalComponent} from "../../../core/visbos-core/ui/forms/generic-modal/generic-modal.component";
import {SessionActions} from "../../../shared/actions/session.actions";
import {
  autoAssignArticles, createMigrationEntry, deleteMigrationEntry, fetchEStoreArticles,
  runEStoreMigration
} from "../../services/e-store-migration.service";
import {
  CreateMigrationEntryMutation, FetchEStoreArticlesQuery,
  FindStockItemsQuery
} from "../../../shared/graphql/graphql.types";
import * as _ from "lodash";
import {Subject} from "rxjs/Subject";
import {StockItem} from "../../../shared/view-model/store-management/stock-item.type";
import {StockItemService} from "../../../store-management/services/stock-item-service/stock-item.service";
import {AdministrationUnit} from "../../../shared/view-model/organization/administration-unit.type";
import {Depot} from "../../../shared/view-model/store-management/depot.type";
import {DepotService} from "../../../store-management/services/depot-service/depot.service";
import {DepotYard} from "../../../shared/view-model/store-management/depot-yard.type";
import {MessageType} from "../../../shared/redux-store/session/session.types";
import {StockItemFormComponent} from "../../../store-management/stock-item/stock-item-form/stock-item-form.component";

@Component({
  selector: 'vb-e-store-migration-view',
  templateUrl: './e-store-migration-view.component.html',
  styleUrls: ['./e-store-migration-view.component.css']
})
export class EStoreMigrationViewComponent extends AbstractVisbosComponent implements OnInit {

  @ViewChild('selectArticleTmpl')
  private selectArticleTmpl: TemplateRef<any>;

  @ViewChild('migrateTmpl')
  private migrateTmpl: TemplateRef<any>;

  @ViewChild('selectDepotTmpl')
  private selectDepotTmpl: TemplateRef<any>;

  private eStoreArticles$: ApolloQueryObservable<FetchEStoreArticlesQuery>;
  private _eStoreArticles: any[] = [];

  private depots$: ApolloQueryObservable<Depot[]>;
  depots: Depot[] = [];

  private depotYards$: ApolloQueryObservable<DepotYard[]>;
  depotYards: DepotYard[] = [];

  columns = [];

  migrationDataControl: FormGroup;

  newArticleControl: FormGroup;

  migrationEntries: Map<number, any> = new Map();
  metaDataEntries: Map<number, any> = new Map();

  runMigrationDisabledProxy = () => this.migrationDataControl.invalid;

  actions = [
    {
      icon: 'fa-plus',
      label: 'Neuer Artikel',
      action: () => this.showNewStockItemModal.apply(this),
      helpText: 'Einen neuen Artikel anlegen'
    },
    {
      icon: 'fa-arrow-right',
      label: 'VisBOS-Artikel automatisch zuweisen',
      action: () => this.onAutoAssignArticles.apply(this),
      helpText: 'Soweit möglich werden den eStore-Artikeln Artikel aus VisBOS automatisch zugewiesen (Abgleich über Artikelnummer)'
    },
    {
      icon: 'fa-forward',
      label: 'Migration durchführen',
      action: () => this.onRunMigration.apply(this),
      helpText: 'Alle zugeordneten Artikel aus eStore nach VisBOS migrieren',
      disabled: () => this.runMigrationDisabledProxy.apply(this)
    }
  ];

  @ViewChild('stockItemModal')
  stockItemModal: GenericModalComponent;

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef,
              private stockItemService: StockItemService,
              private depotService: DepotService,
              private apollo: Apollo,
              private fb: FormBuilder) {
    super(sessionActions, cd);
  }

  private searchToken$: Subject<string> = new Subject();
  currentSuggestions = [];

  private stockItemSearch$: ApolloQueryObservable<FindStockItemsQuery>;

  ngOnInit() {
    super.ngOnInit();

    this.columns = [
      //{prop: 'ean', name: 'EAN', flexGrow: 1},
      {prop: 'beschreibung', name: 'eStore+ Artikel', flexGrow: 3, frozenLeft: true},
      {name: 'Ausschließen', cellTemplate: this.migrateTmpl, sortable: false, flexGrow: 1},
      {name: 'VisBOS Artikel', cellTemplate: this.selectArticleTmpl, sortable: false, flexGrow: 3},
      {name: 'Lager', cellTemplate: this.selectDepotTmpl, sortable: false, flexGrow: 3},
    ];

    this.migrationDataControl = this.fb.group({
      location_id: [null, Validators.required],
      administration_unit_id: [null, Validators.required],
      depot_id: [null, Validators.required],
      only_unprocessed: [null]
    });

    this.eStoreArticles$ = this.apollo.watchQuery<FetchEStoreArticlesQuery>({
      query: fetchEStoreArticles,
      variables: {
        locID: this.migrationDataControl.get('location_id').valueChanges,
        onlyUnprocessed: this.migrationDataControl.get('only_unprocessed').valueChanges
      }
    });

    this.addComponentData(this.eStoreArticles$);
    this.dataSubscriptions.push(this.eStoreArticles$.subscribe(res => this.eStoreArticles = res.data.eStoreArticles));

    this.migrationDataControl.patchValue({
      location_id: 1,
      only_unprocessed: true
    });

    this.stockItemSearch$ = this.stockItemService.findStockItems(this.searchToken$);
    this.addComponentData(this.stockItemSearch$);
    this.dataSubscriptions.push(this.stockItemSearch$.subscribe(res => this.currentSuggestions = res.data.findStockItems));

    this.depots$ = this.depotService.getDepotsList(this.migrationDataControl.get('administration_unit_id').valueChanges);
    this.addComponentData(this.depots$);
    this.dataSubscriptions.push(this.depots$.subscribe((depots: any) => this.depots = depots));

    this.depotYards$ = this.depotService.getDepotYards(this.migrationDataControl.get('depot_id').valueChanges);
    this.addComponentData(this.depotYards$);
    this.dataSubscriptions.push(this.depotYards$.subscribe((yards: any) => this.depotYards = yards));

  }

  public showNewStockItemModal() {
    this.newArticleControl = StockItemFormComponent.initControl(this.fb);
    this.stockItemModal.show();
  }

  public saveStockItem() {
    this.stockItemService.createStockItem(this.newArticleControl.value).toPromise()
      .then(res => this.sessionActions.pushMessage("Artikel angelegt!", MessageType.SUCCESS))
      .catch(err => this.sessionActions.throwError(err, "Fehler beim Anlegen des Artikels!"));
  }

  getMigrationentriesAsArray() {
    return _.toArray(this.migrationEntries.values());
  }

  searchStockItem(event) {

    if (!event || !event.query || event.query == '') {
      return;
    }

    this.searchToken$.next(event.query);

  }

  onAdminUnitSelected(adminUnit: AdministrationUnit) {
    this.migrationEntries.forEach(e => e.administration_unit_cuid = adminUnit.cuid);
    this.migrationDataControl.get('depot_id').reset();
  }

  onDepotSelected(depot?: Depot) {
    this.migrationEntries.forEach(e => {
      e.depot_cuid = depot ? depot.cuid : null;
      e.depot_yard_cuid = null;
    });
  }

  onDepotYardSelected(row, depotYard?: DepotYard) {
    this.migrationEntries.get(row.id).depot_yard_cuid = depotYard ? depotYard.cuid : null;
  }

  onStockItemSelect(row, stockItem?: StockItem) {
    this.migrationEntries.get(row.id).stock_item_cuid = stockItem ? stockItem.cuid : null;
  }

  onStockItemClear(row) {
    this.migrationEntries.get(row.id).stock_item_cuid = null;
  }

  onEntrySave(row) {
    this.metaDataEntries.get(row.id).stored = true;
    this.apollo.mutate<CreateMigrationEntryMutation>({
      mutation: createMigrationEntry,
      variables: {
        input: this.migrationEntries.get(row.id)
      }
    }).toPromise()
      .then(res => {
        console.info("Success!");
        this.metaDataEntries.get(row.id).migration_entry = res.data.createMigrationEntry;
      })
      .catch(err => {
        this.sessionActions.throwError(err, "Fehler beim Speichern der Migrations-Regel!");
        this.metaDataEntries.get(row.id).stored = false;
      });
  }

  onEntryDelete(row) {
    this.metaDataEntries.get(row.id).stored = false;
    this.apollo.mutate({
      mutation: deleteMigrationEntry,
      variables: {
        id: this.metaDataEntries.get(row.id).migration_entry.id
      }
    }).toPromise()
      .then(res => {
        this.metaDataEntries.get(row.id).migration_entry = null;
      })
      .catch(err => {
        this.sessionActions.throwError(err, "Fehler beim Löschen der Migrations-Regel!");
        this.metaDataEntries.get(row.id).stored = true;
      });
  }

  onRunMigration() {

    this.sessionActions.pushMessage("Die Migration wird ausgeführt. Dieser Vorgang kann einige Minuten dauern. Sie werden nach dem Abschluss der Migration informiert!!", MessageType.INFO, "Migration eStore+ -> VisBOS");

    this.apollo.mutate({
      mutation: runEStoreMigration,
      variables: {
        eStoreLocationId: this.migrationDataControl.get('location_id').value,
        visbosAdminUnitCuid: this.migrationDataControl.get('administration_unit_id').value
      }
    }).toPromise()
      .then(res => {
        this.sessionActions.pushMessage("Migration erfolgreich durchgeführt!", MessageType.SUCCESS, "Migration eStore+ -> VisBOS");
      })
      .catch(err => {
        this.sessionActions.throwError(err, "Fehler beim Speichern der Migrations-Regel!");
      });
  }

  onAutoAssignArticles() {

    this.sessionActions.pushMessage("Die Artikel werden identifiziert und zugeordnet, dies kann einen Moment dauern!", MessageType.INFO, "Migration eStore+ -> VisBOS");

    this.apollo.mutate({
      mutation: autoAssignArticles,
      variables: {
        eStoreLocationId: this.migrationDataControl.get('location_id').value,
        vbDepotCuid: this.migrationDataControl.get('depot_id').value
      }
    }).toPromise()
      .then(res => {
        this.sessionActions.pushMessage("Artikel wurden erfolgreich zugeordnet!", MessageType.SUCCESS, "Migration eStore+ -> VisBOS");
      })
      .catch(err => {
        this.sessionActions.throwError(err, "Fehler beim automatischen Zuweisen von Artikeln!");
      });

  }

  set eStoreArticles(value: any[]) {
    this._eStoreArticles = value;
    this.initialized = false;
    this.migrationEntries = new Map();
    this.metaDataEntries = new Map();
    for (let article of value) {
      const newEntry = {
        e_store_id: article.id,
        e_store_standort_id: article.standort_id,
        do_not_migrate: article.migration_entry ? article.migration_entry.do_not_migrate : false,
        administration_unit_cuid: article.migration_entry && article.migration_entry.administration_unit ? article.migration_entry.administration_unit.cuid : this.migrationDataControl ? this.migrationDataControl.get('administration_unit_id').value : null,
        stock_item_cuid: (article.migration_entry && article.migration_entry.stock_item) ? article.migration_entry.stock_item.cuid : null,
        depot_cuid: (article.migration_entry && article.migration_entry.depot) ? article.migration_entry.depot.cuid : (this.migrationDataControl ? this.migrationDataControl.get('depot_id').value : null),
        depot_yard_cuid: (article.migration_entry && article.migration_entry.depot_yard) ? article.migration_entry.depot_yard.cuid : null,
      };
      const newSearchEntry = {
        stock_item_search: article.migration_entry ? article.migration_entry.stock_item : null,
        stored: article.migration_entry ? true : false,
        migration_entry: article.migration_entry ? article.migration_entry : null
      };
      this.migrationEntries.set(article.id, newEntry);
      this.metaDataEntries.set(article.id, newSearchEntry);
    }
    this.initialized = true;
  }

  get eStoreArticles(): any[] {
    return this._eStoreArticles;
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/views/e-store-migration-view/e-store-migration-view.component.ts